import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  width: 220,
  height: 220,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  backgroundColor: '#ffffff',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  },
  margin: theme.spacing(2),
  borderRadius: 16,
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  border: '1px solid #e0e0e0',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 140,
  height: 140,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  '& img': {
    width: '90%',
    height: '90%',
    objectFit: 'contain',
    display: 'block',
  }
}));

const DesignModuleCard = ({ title, icon, onClick }) => {
  return (
    <StyledCard onClick={onClick}>
      <CardContent 
        sx={{ 
          textAlign: 'center', 
          p: 3, 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconWrapper>
          {icon}
        </IconWrapper>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            fontSize: '1.25rem',
            fontWeight: 500,
            color: '#333',
          }}
        >
          {title}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default DesignModuleCard; 